import { __decorate } from "tslib";
import { customElement } from "@microsoft/fast-element";
import { TreeViewTemplate as template, TreeView } from "@microsoft/fast-foundation";
import { TreeViewStyles as styles } from "./tree-view.styles";
/**
 * The FAST tree view Custom Element. Implements, {@link @microsoft/fast-foundation#TreeView}
 * {@link @microsoft/fast-foundation#TreeViewTemplate}
 *
 *
 * @public
 * @remarks
 * HTML Element: \<fast-tree-view\>
 *
 */
let FASTTreeView = class FASTTreeView extends TreeView {
};
FASTTreeView = __decorate([
    customElement({
        name: "fast-tree-view",
        template,
        styles,
    })
], FASTTreeView);
export { FASTTreeView };
/**
 * Styles for TreeView
 * @public
 */
export const TreeViewStyles = styles;
